export const styles = {
  modal: {
    '& .MuiDialog-paper': {
      maxWidth: 900,
      width: '100%',
    },
    '& .MuiDialogTitle-root': {
      padding: '10px 10px 0px',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 20px 32px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0px',
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      marginRight: 8,
    },
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  inputLabel: {
    textAlign: 'left',
    fontSize: 16,
    color: '#546b81',
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    margin: '10px 0 10px 0',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    '& span': {
      fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    },
  },
  errorLabel: {
    color: 'red',
    height: 22,
  },
  fieldHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
    color: '#4A4A4A',
    fontSize: 16,
    '& .MuiSvgIcon-root': {
      fontSize: 18,
      color: '#757575',
      cursor: 'help',
    },
  },
  helper: {
    color: '#757575',
    fontSize: '14px',
    marginTop: '8px',
  },
  zipResults: {
    position: 'absolute',
    width: '100%',
    maxHeight: '152px',
    overflowY: 'auto',
    zIndex: 1000,
    marginTop: '4px',
    '& .MuiListItem-root': {
      padding: '6px 16px',
      fontSize: '14px',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
    '& .MuiListItemText-primary': {
      fontSize: '14px',
    },
  },
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 0,
  },
  chip: {
    backgroundColor: '#646478',
    borderRadius: 4,
    color: '#fff',
    marginRight: 8,
    marginTop: 16,
    cursor: 'default',
    '&:hover': {
      backgroundColor: '#646478',
    },
    '& .MuiChip-label': {
      padding: '6px 12px 6px 8px',
      fontSize: '14px',
    },
    '& .MuiChip-deleteIcon': {
      color: '#fff',
      fontSize: '16px',
      margin: '0 8px 0 0',
      padding: 0,
      cursor: 'pointer',
      '&:hover': {
        color: '#fff',
      },
    },
    '& .MuiChip-root': {
      backgroundColor: 'transparent',
    },
    '& .MuiChip-deletable': {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
  },
  locationSection: {
    margin: '26px 0 0',
    '& .MuiRadio-root': {
      color: '#004360',
      '&.Mui-checked': {
        color: '#004360',
      },
    },
  },

  tooltipContent: {
    color: '#000000DE',
    fontSize: 16,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    lineHeight: '24px',
  },
  missionNumberField: {
    width: '394px',
  },
  basPerMissionField: {
    width: '182px',
  },

  startDateField: {
    width: '182px',
  },
  zipSearchContainer: {
    width: '100%',
    position: 'relative',
  },
  modalButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 26,
  },
  cancelButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    border: '1px solid #004360',
    color: '#004360',
    backgroundColor: '#FFFFFF',
    padding: '8px 16px',
    maxWidth: '86px',
    fontWeight: 700,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    cursor: 'pointer',
    '&:hover': {
      border: '1px solid #004360',
      color: '#FFFFFF',
      backgroundColor: '#004360',
    },
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    border: '1px solid #004360',
    color: '#FFFFFF',
    padding: '8px 16px',
    backgroundColor: '#004360',
    maxWidth: '86px',
    fontWeight: 700,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    cursor: 'pointer',
    '&:hover': {
      border: '1px solid #004360',
      color: '#004360',
      backgroundColor: '#FFFFFF',
    },
  },
  disabledButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    color: 'rgba(0, 0, 0, 0.26)',
    padding: '8px 16px',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    maxWidth: '86px',
    fontWeight: 700,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    cursor: 'not-allowed',
  },

  editZipCodes: {
    color: '#004360',
    fontSize: 14,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    lineHeight: '24px',
    textDecoration: 'underline',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
  },
  limit: {
    fontSize: 14,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    color: '#505050',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 4,
  },
  result: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '32px',
    '&  div': {
      fontSize: 16,
      fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
      color: '#000000',
      textAlign: 'center',
    },
  },
  placeholder: {
    padding: '6px 16px',
    fontSize: '14px',
  },
  listItemContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  listItemMainText: {
    fontSize: 16,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    color: '#011533',
  },
  listItemSubText: {
    fontSize: 14,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    color: '#505050',
  },
  noDistributionZoneWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& div:first-child': {
      fontSize: 14,
      fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
      color: 'red',
    },
  },
  progressContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  progressBar: {
    height: 8,
    borderRadius: 4,
  },
  mockHeight: {
    height: 30,
  },
}
